import Layout from "./layout.js";
import Root from "../components/Root.js";

import "../styles.scss";

export default () => (
  <Layout>
    <Root />
  </Layout>
);

